<template>
  <dev class="queue-card" shadow="hover">
    <div class="queue-left">
      <i class="fas fa-layer-group"></i>
      <span>{{ $t('manga.queueCard.publicQueue') }}</span>
      <span class="queue-num">{{ queueCount }}</span>
      <span>{{ $t('manga.queueCard.people') }}</span>
    </div>
    <div class="queue-right">
      <span>{{ $t('manga.queueCard.realtime') }}</span>
    </div>
  </dev>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  queueCount: {
    type: Number,
    default: 0
  }
})
</script>

<style scoped>
.queue-card {
      background: rgba(30, 41, 59, 0.6);
      border: 1px solid rgba(94, 234, 212, 0.2);
      border-radius: 12px;
      padding: 1.2rem 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1.5rem;
      backdrop-filter: blur(10px);
      transition: all 0.3s ease;
}

.queue-card:hover{
  border-color: rgba(94, 234, 212, 0.3);
  box-shadow: 0 4px 20px rgba(94, 234, 212, 0.1);
}

.queue-left {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #cbd5e1;
}

.queue-left i {
  color: #5eead4;
  font-size: 1.2rem;
}

.queue-num {
  font-size: 1.8rem;
  font-weight: bold;
  color: #5eead4;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.queue-right {
  color: #94a3b8;
  font-size: 0.9rem;
}

@media (max-width: 500px) {
  .queue-card {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }

  .queue-left {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>